// NodeFieldData.js

export function resolveNodeFieldDataKey(field, nodeTypeKey) {
  const source = String(field?.source || nodeTypeKey || '').trim().toLowerCase();
  if (!source) return null;
  return `data_${source}`;
}

export function readNodeFieldRawValue(node, field, nodeTypeKey) {
  const nodeDataKey = resolveNodeFieldDataKey({ source: nodeTypeKey }, nodeTypeKey);
  if (nodeDataKey && field?.name && node?.[nodeDataKey]?.[field.name] !== undefined) {
    return node[nodeDataKey][field.name];
  }

  const dataKey = resolveNodeFieldDataKey(field, nodeTypeKey);
  if (!dataKey || !field?.name) return undefined;

  const direct = node?.[dataKey]?.[field.name];
  if (direct !== undefined) return direct;

  return undefined;
}

export function buildNodeFieldPatch(node, field, nodeTypeKey, value) {
  const dataKey = resolveNodeFieldDataKey({ source: nodeTypeKey }, nodeTypeKey)
    || resolveNodeFieldDataKey(field, nodeTypeKey);
  if (!dataKey || !field?.name) return null;

  const dataObj = node?.[dataKey] || {};
  return { [dataKey]: { ...dataObj, [field.name]: value } };
}